import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { pagesPATH } from '../../models_new/config/pages';
import { SimulationDetailsComponent } from 'src/app/components/simulation/simulation-details/simulation-details.component';
import { SimulationComponent } from 'src/app/components/simulation/simulation.component';
import { SimulationPageComponent } from 'src/app/components/simulation/simulation-page/simulation-page.component';
import { SimulationRetryComponent } from 'src/app/components/simulation/simulation-retry/simulation-retry.component';
import { SimpleSimulationContainerComponent } from 'src/app/components/simulation/simple-simulation/simple-simulation-container/simple-simulation-container.component';
import { SimulationWizardContainerComponent } from 'src/app/components/simulation/simulation-wizard/gui-container/simulation-wizard-container.component';
import { OrganizationContextResolver } from '../../resolvers/organization-context-resolver.resolver';
import { SimulationsComponent } from '../../components/inventory/simulations/simulations.component';
import { AuthGuard } from '@auth0/auth0-angular';
import { EulaGuard } from 'src/app/auth/eula.guard';
import { InstalledRobotSimulationWizardComponent } from 'src/app/components/simulation/installed-robot-simulation-wizard/installed-robot-simulation-wizard.component';
import { BrandsGuard } from 'src/app/auth/brands.guard';
import { SubscriptionGuard } from 'src/app/auth/subscription.guard';

const simulationRoutes: Routes = [
  {
    path: '',
    component: SimulationComponent,
    children: [
      {
        path: '',
        component: SimulationsComponent,
        data: {
          breadcrumb: 'Simulations',
        },
        resolve: { organization_id: OrganizationContextResolver },
        canActivate: [AuthGuard, BrandsGuard, SubscriptionGuard],
      },
      {
        path: pagesPATH.SIMPLE_SIMULATION + '/:id',
        component: SimpleSimulationContainerComponent,
        data: {
          breadcrumb: 'Simple simulation',
        },
        resolve: { organization_id: OrganizationContextResolver },
        canActivate: [AuthGuard, BrandsGuard, SubscriptionGuard],
      },
      {
        path: pagesPATH.INSTALLED_ROBOT_SIMULATION_WIZARD + '/:id',
        component: InstalledRobotSimulationWizardComponent,
        data: {
          breadcrumb: 'Installed robot simulation wizard',
        },
        resolve: { organization_id: OrganizationContextResolver },
        canActivate: [AuthGuard, BrandsGuard, SubscriptionGuard],
      },
      {
        path: pagesPATH.SIMULATION_WIZARD,
        component: SimulationWizardContainerComponent,
        data: {
          breadcrumb: 'Simulation wizard',
        },
        canActivate: [AuthGuard, BrandsGuard, SubscriptionGuard],
      },
      {
        path: pagesPATH.SIMULATIONVISUALIZATION + '/:id',
        component: SimulationPageComponent,
        data: {
          breadcrumb: 'Simulation Visualization',
        },
        resolve: { organization_id: OrganizationContextResolver },
        canActivate: [AuthGuard, BrandsGuard, SubscriptionGuard],
      },
      {
        path: pagesPATH.SIMULATION_RETRY + '/:id',
        component: SimulationRetryComponent,
        data: {
          breadcrum: 'Fix & Retry Simulation',
        },
        resolve: { organization_id: OrganizationContextResolver },
        canActivate: [AuthGuard, BrandsGuard, SubscriptionGuard],
      },
      {
        path: ':id',
        component: SimulationDetailsComponent,
        canActivate: [EulaGuard],
        data: {
          breadcrumb: 'Simulation Details',
        },
      },
      {
        path: '**',
        redirectTo: '',
        pathMatch: 'full',
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(simulationRoutes)],
  exports: [RouterModule],
})
export class SimulationRoutingModule {}
